import { InfobarShowHideDetailsPartProps } from './InfoBarComponentProps';
import * as React from 'react';

const InfobarShowHideDetailsPart = (props: InfobarShowHideDetailsPartProps) => {
    const { isShowingDetails, clickHandler, detailsElement } = props;

    return (
        <span>
            <a href={'javascript:void(0);'} className={props.className} onClick={clickHandler}>
                {isShowingDetails ? props.hideDetailsText : props.showDetailsText}
            </a>
            {isShowingDetails && detailsElement}
        </span>
    );
};

export default InfobarShowHideDetailsPart;
